/* NL Press — category filter (spans all press sections on the page) + image lightbox */
(function(){
  if(window.__nlPress) return; window.__nlPress = true;
  function ready(fn){ document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',fn) : fn(); }
  ready(function(){
    var bar = document.querySelector('[data-pr-filterbar]');
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-pr-item]'));
    var chips = bar ? Array.prototype.slice.call(bar.querySelectorAll('[data-filter]')) : [];
    var count = document.querySelector('[data-pr-count]');
    var empty = document.querySelector('[data-pr-empty]');
    var valid = chips.map(function(c){ return c.getAttribute('data-filter'); });

    function apply(f, push){
      var n = 0;
      items.forEach(function(el){
        var show = f === 'all' || el.getAttribute('data-cat') === f;
        el.hidden = !show; if(show) n++;
      });
      chips.forEach(function(c){
        var on = c.getAttribute('data-filter') === f;
        c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if(count) count.textContent = n;
      if(empty) empty.hidden = n > 0;
      if(push){ try{ history.replaceState(null,'', f === 'all' ? location.pathname + location.search : '#' + f); }catch(e){} }
    }
    chips.forEach(function(c){ c.addEventListener('click', function(){
      apply(c.getAttribute('data-filter'), true);
      var m = document.querySelector('.pr-main');
      if(m && window.scrollY > m.offsetTop){ m.scrollIntoView({behavior:'smooth', block:'start'}); }
    }); });
    var h = (location.hash || '').replace('#','');
    apply(valid.indexOf(h) > -1 ? h : 'all', false);

    /* lightbox for items without a link */
    var lb = document.querySelector('[data-pr-lightbox]');
    if(!lb) return;
    var img = lb.querySelector('img'), cap = lb.querySelector('figcaption');
    function close(){ if(lb.close) lb.close(); else lb.removeAttribute('open'); }
    document.addEventListener('click', function(e){
      var z = e.target.closest && e.target.closest('[data-pr-zoom]');
      if(z){
        var src = z.getAttribute('data-full'); if(!src) return;
        img.src = src; img.alt = z.getAttribute('data-caption') || ''; cap.textContent = z.getAttribute('data-caption') || '';
        if(lb.showModal) lb.showModal(); else lb.setAttribute('open','');
        return;
      }
      if(e.target === lb || (e.target.closest && e.target.closest('[data-pr-lb-close]'))) close();
    });
  });
})();